import React from 'react'
import { Box,Typography,Button, Card, Chip } from "@material-ui/core";
import { AlertDialog } from '../../../componentes/MUI/AlertDialog';
import {FormularioTramite} from '../../FormularioTramite'
import {TramiteContextProvider} from '../contexto/tramiteContext'
import {useTramite} from '../hooks/useTramite'
import {SeccionAceptacionDocs} from '../componentes/SeccionAceptacionDocs'
import {UbicacionInicial} from '../componentes/UbicacionInicial'
import {DatosPersonales} from '../componentes/DatosPersonales'
import {Contacto} from '../componentes/Contacto'
import {Cuestionario} from '../componentes/Cuestionario'
import {Cuestionario2} from '../componentes/Cuestionario2'
import {Pastores} from '../componentes/Pastores'
import {PantallaInicial} from '../componentes/PantallaInicial'
import {ArchivosAdjuntos} from '../componentes/ArchivosAdjuntos'
import {Referencias} from '../componentes/Referencias'
import {eliminarArchivos} from '../../../Helpers/utilidades-globales'
import Aceptaciones1raCredencial from '../../../componentes/Aceptaciones1raCredencial';
import { 
  ArrowLeftIcon, 
} from '@heroicons/react/24/outline'; 

import {usePrimeraCredencial} from '../hooks/usePrimeraCredencial'
import { set } from 'date-fns';
import { ca } from 'date-fns/locale';

export const InicioTramite = ({finalizar,datosPatrocinante,cancelar})=>{

const {
    // --- ESTADOS DE CARGA Y NAVEGACIÓN ---
    loadingFile,
    continuar,
    setContinuar,
    validarCampos,

    // --- ESTADOS DE DATOS ---
    objetoDinamico,
    setObjetoDinamico,
    documento,
    setDocumento,
    lecturas,
    setLecturas,

    // --- ESTADOS DE ARCHIVOS (FILES) ---
    analiticoFile,
    setAnaliticoFile,
    dniFrenteFile,
    setDniFrenteFile,
    dniReversoFile,
    setDniReversoFile,
    foto4x4File,
    setFoto4x4File,
    antecedentes_penFile,
    setAntecedentesPenFile,
    certificadoMatrimonioFile,
    setCertificadoMatrimonioFile,
    otroArchivo,
    setOtroArchivo,

    // --- MÉTODOS DE MANEJO DE EVENTOS ---
    handleAceptacion,
    iniciarContinuar,

    // --- MÉTODOS DE VALIDACIÓN ---
    callbackPrevio,
    callbackValidate,
    validarCondicionesInicialesPaso1,
    validarCondicionesInicialesPaso2,
    validarCondicionesInicialesPaso3,
    validarCondicionesInicialesPaso4,
    validarCondicionesInicialesPaso5,
    validarCondicionesInicialesPaso6,
    validarCondicionesInicialesPaso7,

    // --- COMPONENTES E INYECTADOS ---
    CustomSubmit, // Componente para el proceso de SMS y Submit
    
    // --- DATOS EXTERNOS RE-EXPUESTOS (Opcional, pero útil) ---
    usuario,
    campos_formulario,
    provincias,
    partidos,
    tiposDoc,
    nacionalidades,
    estadosCiviles,
    adjuntos,

    determinarEstado,
    determinarNombreDocumento
} = usePrimeraCredencial({datosPatrocinante});


if (continuar === false){
  return <PantallaInicial 
      datosPatrocinante = {datosPatrocinante}
      iniciarContinuar = {iniciarContinuar}
      documento = {documento}
      setDocumento = {setDocumento}
      lecturas = {lecturas}
      setLecturas = {setLecturas}
      cancelar = {cancelar}
      />
}

   if (continuar === true) {
  return (
    <TramiteContextProvider>
      <div className="min-h-screen bg-slate-50 py-10 px-4 sm:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">
          
          <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
            <div className="flex items-center gap-4">
              <Button 
                variant="text" 
                color="blue-gray" 
                onClick={() => setContinuar(false)}
                className="flex items-center gap-2 rounded-full pl-2 pr-4 py-2 capitalize font-semibold"
              >
                <ArrowLeftIcon className="h-5 w-5" />
                Volver
              </Button>
            </div>
            <Chip 
              value="Nuevo Ministro" 
              variant="ghost" 
              color="blue" 
              className="rounded-full px-4 text-xs font-bold"
            />
          </div>

          <Card className="p-6 md:p-10 shadow-2xl shadow-slate-200 border border-slate-100 rounded-[2rem]">
                <Box className='flex justify-center items-center mb-5'>
                  <Typography variant="h5">Solicitud de credenciales para nuevo ministro</Typography>
                </Box>
            <AlertDialog 
              open={documento} 
              titulo={'Conformidad y Aceptación'} 
              fullWidth={true} 
              maxWidth={'md'}
              procesarCancelar={() => setDocumento(null)}
            >
              <Aceptaciones1raCredencial 
                tipo={documento} 
                update={handleAceptacion} 
                objLecturas={{lecturas, setLecturas}}
                nombreDocumento={determinarNombreDocumento(documento)}
                instancia='aceptacion' 
                estado={determinarEstado(documento, objetoDinamico)}
                finalizar={() => setDocumento(null)}
              />
            </AlertDialog>


            <div className="space-y-12">


        <p style={{color:'red'}}>* Indica que el campo es obligatorio</p>

              <h3 className='text-xl font-medium text-gray-800 mb-1'>Por favor adjunte los siguientes archivos:</h3>

              <ArchivosAdjuntos
                  analiticoFile={analiticoFile}
                  setAnaliticoFile={setAnaliticoFile}
                  dniFrenteFile={dniFrenteFile}
                  setDniFrenteFile={setDniFrenteFile}
                  dniReversoFile={dniReversoFile}
                  setDniReversoFile={setDniReversoFile}
                  foto4x4File={foto4x4File}
                  setFoto4x4File={setFoto4x4File}
                  antecedentes_penFile={antecedentes_penFile}
                  setAntecedentesPenFile={setAntecedentesPenFile}
                  certificadoMatrimonioFile={certificadoMatrimonioFile}
                  setCertificadoMatrimonioFile={setCertificadoMatrimonioFile}
                  otroArchivo={otroArchivo}
                  setOtroArchivo={setOtroArchivo}
                  objetoDinamico={objetoDinamico}
                  loadingFile={loadingFile}
              />

              <h3 className='text-xl font-medium text-gray-800 mb-1'>Por favor revise y acepte cada uno de los siguientes documentos:</h3>

               <SeccionAceptacionDocs 
                  objetoDinamico = {objetoDinamico}
                  setDocumento = {setDocumento}
               />

                <section className="space-y-6">
                  <div className="grid grid-cols-1 gap-8">
                    
                    <div className="bg-white border-l-4 border-blue-500 p-6 rounded-r-2xl shadow-sm border border-slate-100">
                      <DatosPersonales 
                        usuario={usuario} 
                        finalizar={finalizar} 
                        nacionalidades={nacionalidades}
                        estadosCiviles={estadosCiviles}
                        tiposDoc={tiposDoc}
                        validar={validarCampos}
                        validacion={validarCondicionesInicialesPaso1} 
                        paso_cumplido={false}
                        objetoModificacion={{obj:objetoDinamico, set:setObjetoDinamico}}
                      />
                    </div>
                    
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                      <UbicacionInicial 
                        usuario={usuario} 
                        provincias={provincias}
                        partidos={partidos}
                        validar={validarCampos}
                        validacion={validarCondicionesInicialesPaso2} 
                        paso_cumplido={false}
                        objetoModificacion={{obj:objetoDinamico, set:setObjetoDinamico}}
                      />

                      <Contacto 
                        usuario={usuario} 
                        validar={validarCampos}
                        validacion={validarCondicionesInicialesPaso3}
                        paso_cumplido={false}
                        objetoModificacion={{obj:objetoDinamico, set:setObjetoDinamico}}
                      />
                    </div>

                    <div className="space-y-8 bg-slate-50 p-6 rounded-[2rem] border border-slate-200">
                      <Cuestionario 
                        usuario={usuario} 
                        validar={validarCampos}
                        validacion={validarCondicionesInicialesPaso4} 
                        paso_cumplido={false}
                        objetoModificacion={{obj:objetoDinamico, set:setObjetoDinamico}}
                      />

                      <Cuestionario2 
                        usuario={usuario} 
                        validar={validarCampos}
                        validacion={validarCondicionesInicialesPaso5} 
                        paso_cumplido={false}
                        objetoModificacion={{obj:objetoDinamico, set:setObjetoDinamico}}
                      />

                      <Pastores 
                        usuario={usuario} 
                        validar={validarCampos}
                        validacion={validarCondicionesInicialesPaso6} 
                        paso_cumplido={false}
                        objetoModificacion={{obj:objetoDinamico, set:setObjetoDinamico}}
                      />

                      <Referencias 
                        usuario={usuario} 
                        validar={validarCampos}
                        validacion={validarCondicionesInicialesPaso7} 
                        paso_cumplido={false}
                        objetoModificacion={{obj:objetoDinamico, set:setObjetoDinamico}}
                      />
                    </div>
                  </div>
                </section>

                <FormularioTramite 
                  finalizar={finalizar}
                  callbackPrevio={callbackPrevio}
                  objetoDinamico={objetoDinamico}
                  campos_formulario={campos_formulario}
                  textoSumbit="Enviar Solicitud de Nuevo Ministro"
                  callbackError={() => eliminarArchivos(adjuntos)}
                  cancelar={cancelar}
                  CustomSubmit={CustomSubmit}
                  preguntararSiCancela={{texto1:'Puede perder los datos cargados', texto2:'¿Desea confirmar la cancelación?'}}
                  callbackValidatePlus={callbackValidate}
                  useTramite={useTramite}
                />

            </div>
          </Card>
        </div>
      </div>
    </TramiteContextProvider>
  );
}
}

